export const TWITTER_UUID_NAMESPACE = '2ee81dbd-432b-4bff-ac95-e93524efdaf8';
